import { useEffect, useState } from 'react';
import { intervalToDuration, isBefore } from 'date-fns';

interface Props {
  endTime?: Date;
  onFinish?: () => void;
}
export const useCountdownTimer = ({ endTime, onFinish }: Props) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    if (!endTime) return;

    if (isBefore(endTime, new Date())) {
      onFinish?.();
      return;
    }

    const interval = setInterval(() => {
      const current = new Date();
      if (isBefore(endTime, current)) {
        clearInterval(interval);
        setNow(endTime);
        onFinish?.();
      } else {
        setNow(current);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime?.getTime()]);

  if (!endTime) return null;

  return intervalToDuration({ start: now, end: endTime });
};
